<label [formGroup]="control" for="{{config.property}}-checkbox" class="wb-description {{hasErrors ? 'error' : ''}}">
  <input type="checkbox"
    id="{{config.property}}-checkbox"
    [formControlName]="config.property"
    [checked]="this.control.controls[config.property].value"
    (change)="toggle($event)">
    <span [innerHTML]="description | html"></span>
  </label>
  @if (config.helpText) {
    <span class="wb-help"
      (click)="toggleHelpModal(config.label, config.helpText)"><app-svg-icon [icon]="faInfoCircle"></app-svg-icon>
    </span>
  }
  <app-field-error [config]="config" (validityChanged)="validityChanged($event)"></app-field-error>
